export const PUBLIC_ENV_VARS = {
  ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
  GOOGLE_ANALYTICS_MEASUREMENT_ID:
    process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  BUILD_TIME: process.env.NEXT_PUBLIC_BUILD_TIME,
};
